<template>
    <div class="profile-view">
        <v-container>
            <v-row align="center">
                <ProfileGroup
                    :groups="user.memberships"
                    type="collective"
                />
                <ProfileGroup
                    :groups="user.memberships"
                    type="project"
                />
                <ProfileGroup
                    :groups="user.memberships"
                    type="competition"
                />  
                <ProfileGroup
                    :groups="user.memberships"
                    type="workshop"
                />
            </v-row>
          </v-container>
          <p>Voted by me: {{ filteredByVoted.length}} </p>
        <PhotoList />
    </div>
</template>

<script>

import { userMixin, imageMixin } from '@/functions/mixins'
import PhotoList from '@/components/image/List'
import ProfileGroup from '@/components/profile/Group'


export default {
    name: 'Profile',
    components: { 
        PhotoList,
        ProfileGroup
    },
    mixins: [userMixin, imageMixin]
}
</script>

<style scoped>
.profile-view {
    padding-top: 50px;
}
</style>